import styled from 'styled-components/macro';
import { AmendmentStatus } from '../../slice/types';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import { Tooltip } from '@mui/material';

export function SectionStatusBlock(props) {
  const { sectionName, sectionStatus, statusReason } = props;

  return (
    <Wrapper>
      {sectionStatus === AmendmentStatus.PENDING && (
        <div>
          <AssignmentLateOutlinedIcon
            style={{
              fontSize: '18px',
              color: 'red',
            }}
          />
          {sectionName}
        </div>
      )}
      {sectionStatus === AmendmentStatus.COMPLETE && (
        <div>
          <AssignmentTurnedInOutlinedIcon
            style={{
              fontSize: '18px',
              color: 'rgba(0, 215, 114, 0.8)',
            }}
          />
          {sectionName}
        </div>
      )}
      {sectionStatus === AmendmentStatus.AUTOComplete && (
        statusReason ? (
          <Tooltip title={statusReason} arrow>
            <div>
              <DoneOutlinedIcon
                style={{
                  fontSize: '18px',
                  color: 'rgba(0, 215, 114, 0.8)',  
                }}
              />
              {sectionName}
            </div>
          </Tooltip>
        ) : ( 
          <div>
            <DoneOutlinedIcon
              style={{
                fontSize: '18px',
                color: 'rgba(0, 215, 114, 0.8)',
              }}
            />
            {sectionName}
          </div>
        )
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: 5px 5px 0 5px;
`;
